var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer ppf-branding-dots"},[(_vm.hasContact)?_c('app-section',{staticClass:"app-section-transparent"},[_c('app-footer-contact',{staticClass:"mt-4 mb-4"})],1):_vm._e(),_c('app-footer-disclaimer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }